/* ============================================================
   tio-antes.js — Ancla tachada y "Ahorra $X" en la ficha
   v2 · 28-ago-2026

   POR QUE EXISTE: tio-pdp.js actualiza [data-tio-pdp-precio] cuando
   cambia el formato, pero no sabe nada de compare-at. En vez de tocar
   ese archivo (28 KB, con la cadena F3 del carrito adentro), este
   script escucha los clicks en los botones de formato y repinta el
   ancla. Si falla, el precio real sigue correcto y el carrito no se
   entera.

   CERO FORMATO DE MONEDA EN JS: los textos ya vienen formateados por
   Liquid con el filtro `money` en data-antes y data-ahorra. Aca solo
   se copian. Asi no hay riesgo de que el JS escriba un monto con
   separadores distintos a los del resto de la tienda.

   REGLA DE ANCLA: solo el formato mas chico lleva compare_at, asi que
   al elegir 3 / 5 / 10 mL no hay data-antes y el bloque se borra. Eso
   es lo esperado, no un error.

   Se carga desde tio-formatos.liquid, que se renderiza DOS veces en la
   ficha (pagina + bottom-sheet); ese snippet ya emite el <script> una
   sola vez y ademas esta el guard de abajo.
   ============================================================ */
(function () {
  if (window.__tioAntes) return;
  window.__tioAntes = true;

  var SEL_PRECIO = '[data-tio-pdp-precio]';
  var SEL_FMT = '[data-tio-pdp-fmt]';

  function activo() {
    // El formato activo de la PAGINA manda: el sheet refleja el mismo estado.
    var todos = document.querySelectorAll(SEL_FMT + '.is-active');
    return todos.length ? todos[0] : document.querySelector(SEL_FMT + '[aria-checked="true"]');
  }

  function pintar() {
    var caja = document.querySelector(SEL_PRECIO);
    if (!caja || !caja.parentNode) return;
    var cont = caja.parentNode;

    var viejoS = cont.querySelector('.pdp-price-antes');
    var viejoA = cont.querySelector('.pdp-price-ahorra');
    if (viejoS) viejoS.remove();
    if (viejoA) viejoA.remove();

    var btn = activo();
    if (!btn) return;

    var antes = btn.getAttribute('data-antes');
    var ahorra = btn.getAttribute('data-ahorra');
    if (!antes) return;

    var s = document.createElement('s');
    s.className = 'pdp-price-antes';
    s.textContent = antes;
    cont.appendChild(s);

    if (ahorra) {
      var a = document.createElement('span');
      a.className = 'pdp-price-ahorra';
      a.textContent = 'Ahorra ' + ahorra;
      cont.appendChild(a);
    }
  }

  function pintarDespues() {
    // setTimeout 0: deja que tio-pdp.js termine de escribir el precio
    // antes de que este script lea el formato activo.
    setTimeout(pintar, 0);
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest(SEL_FMT)) pintarDespues();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pintar);
  } else {
    pintar();
  }
})();
